module.exports = __webpack_public_path__ + "img/detail_D10A.ee948ca3.png";